module.exports = "varying vec3 vPos; \n\n"